import React, { useEffect, useState } from "react";

const Toast = ({ type = "success", identifier, message, onClose }) => {
  const [phase, setPhase] = useState("enter");

  useEffect(() => {
    const t1 = setTimeout(() => setPhase("show"), 50);
    const t2 = setTimeout(() => setPhase("fold"), 3500);
    const t3 = setTimeout(() => onClose(), 5500);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [onClose]);

  const style = {
    transition: phase === "fold"
      ? "transform 2000ms cubic-bezier(0.4,0,0.2,1), opacity 2000ms ease, max-width 2000ms ease"
      : "transform 300ms ease, opacity 300ms ease, max-width 300ms ease",
    transformOrigin: "right",
    transform: phase === "fold" ? "scaleX(0)" : "scaleX(1)",
    opacity: phase === "fold" ? 0 : phase === "enter" ? 0 : 1,
    maxWidth: phase === "fold" ? "0px" : "400px",
    overflow: "hidden",
  };

  const isError = type === "error";

  return (
    <div style={style} className="fixed top-5 right-5 z-50">
      <div className={`flex items-start gap-3 px-4 py-3 rounded-xl shadow-xl border bg-white min-w-[260px] max-w-xs ${isError ? "border-red-300" : "border-green-300"}`}>
        <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${isError ? "bg-red-100" : "bg-green-100"}`}>
          <i className={`fas text-sm ${isError ? "fa-times-circle text-red-500" : "fa-check text-green-600"}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-xs font-bold uppercase tracking-wide mb-0.5 ${isError ? "text-red-600" : "text-green-700"}`}>
            {isError ? "Error" : "Success"}
          </p>
          {identifier && (
            <p className="text-xs font-semibold text-indigo-600 mb-0.5">{identifier}</p>
          )}
          <p className="text-sm text-gray-700 leading-snug whitespace-pre-line">{message}</p>
        </div>
        <button onClick={onClose} className="flex-shrink-0 text-gray-400 hover:text-gray-600 mt-0.5">
          <i className="fas fa-times text-xs" />
        </button>
      </div>
    </div>
  );
};

export default Toast;
